import React, { useReducer, createContext, useContext } from "react";
import { initialState, AuthReducer } from "./reducer";
import { Action, State } from "./types";
const AuthStateContext = createContext<State>({
  user: { refreshToken: "" },
  isAuthenticated: false,
  loading: true,
  authType: "basic",
});
const AuthDispatchContext = createContext<React.Dispatch<Action>>(() => null);

export function useAuthState() {
  const context = useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error("useAuthState must be used within a AuthProvider");
  }

  return context;
}

export function useAuthDispatch() {
  const context = useContext(AuthDispatchContext);
  if (context === undefined) {
    throw new Error("useAuthDispatch must be used within a AuthProvider");
  }

  return context;
}

export const AuthProvider = ({ children }: { children: JSX.Element[] }) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
};
